const mutations = {
  addItemToGuestCart(state, product) {
    state.guestCart.push(product)
  },
  updateGuestCartItemQuantity(state, payload) {
    state.guestCart[payload.index].quantity = payload.quantity
  },
  removeItemFromGuestCart(state, index) {
    state.guestCart.splice(index, 1)
  },
  resetGuestCart(state) {
    state.guestCart = []
  },
  setUserCart(state, cart) {
    state.userCart = cart
  },
  addItemToUserCart(state, item) {
    state.userCart.push(item)
  },
  updateUserCartItemQuantity(state, payload) {
    state.userCart[payload.index].quantity = payload.quantity
  },
  removeItemFromUserCart(state, index) {
    state.userCart.splice(index, 1)
  },
  resetUserCart(state) {
    state.userCart = []
  }
}

export default mutations
